import { analyticContentCostActions } from 'store/actions';
import { IAnalyticContentCostMeta } from 'store/actions/analytics/ROI/contentCost';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<IAnalyticContentCostMeta, GenericResponse>(
  analyticContentCostActions,
);
